module.exports = __webpack_public_path__ + "assets/img/vampire-attack.3eabcc10.png";